import { UseMenuInterface } from '@hooks/useMenu';
import { MenuItem } from '@mui/material';

const PrintQueueMenu = ({
  menu,
  handleOpenDialog,
}: {
  menu: UseMenuInterface;
  handleOpenDialog: () => void;
}) => {
  const { MenuWrapper, handleClose } = menu;

  return (
    <MenuWrapper>
      <MenuItem
        key='t-edit'
        onClick={() => {
          handleClose();
          handleOpenDialog();
        }}
      >
        Delete
      </MenuItem>
    </MenuWrapper>
  );
};

export default PrintQueueMenu;
